import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlBillingParty} from '../getBillingParty.api';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

export interface PayingMemberCreate {
    __typename: undefined
    id: undefined
    billingParty: undefined
    billing_party_id: undefined
    user: undefined
    user_id: undefined
    payments?: undefined

    first_name: string
    last_name: string
    email: string
    address_line_1: string
    address_line_2: string
    city: string
    state: string
    zipcode: string
    country: string
    primary_phone: string
    primary_phone_code: string
    secondary_phone: string
    secondary_phone_code: string
    primary_paying_member: boolean
    notes: string
    is_group_leader: boolean
}

export interface CreateBillingPartyInput {
    data: {
        group_id: number
        start_date: Date | string
        end_date: Date | string
        credit_card_fee: number
        credit_card_fee_paid?: boolean
        soft_cancelled: boolean
        disabled: boolean
        payments?: undefined
        billing_party_member: PayingMemberCreate;
    }
}

interface CreateBillingPartyData {
    createBillingParty: BillingParty
}

export const CREATE_BILLING_PARTY_MUTATION = gql`
    mutation createBillingParty($data: CreateBillingPartyInput!) {
        createBillingParty(data: $data) {
            ${gqlBillingParty}
        }
    }
`;

export const createBillingParty = () => useMutation<CreateBillingPartyData, CreateBillingPartyInput>(
    CREATE_BILLING_PARTY_MUTATION,
    {
      update: updateCacheByType('BillingParty'),
    }
);

export default createBillingParty;
